export default {
  HOME: '/',
  PROJECTS: '/projects',
  Skill: '/skill',
  FEEDBACK: '/feedback',
  TEAM: '/team',
  CONTACT: '/contact',
  DETAILS: '/projects/:id'
}
